import Vue from 'vue';
import config from '@/config/config.json';
import { PAGE_ROUTES } from '@/constants/routes';
import NotificationService from '@/helpers/notification';

class PageApiService {
  constructor() {}

  async getAll() {
    return (await Vue.prototype.$http.get(
      `${config.apiUrl}${PAGE_ROUTES.BASE_URL}`
    )).data;
  }

  async save(id, page) {
    const response = await Vue.prototype.$http
      .post(`${config.apiUrl}${PAGE_ROUTES.BASE_URL}${id ? '/' + id : ''}`, page)
      .catch(error => NotificationService.error(error.message));

    if (!!response) {
      NotificationService.success('Page has been saved.');
    }
  }

  async delete(id) {
    const response = await Vue.prototype.$http
      .delete(`${config.apiUrl}${PAGE_ROUTES.BASE_URL}/${id}`)
      .catch(error => NotificationService.error(error.message));

    if (!!response) {
      NotificationService.success('Page has been deleted.');
    }
  }

  async publish(id) {
    const response = await Vue.prototype.$http.put(
      `${config.apiUrl}${PAGE_ROUTES.BASE_URL}/${id}/${PAGE_ROUTES.PUBLISH}`
    );

    if (!!response) {
      NotificationService.success('Page has been published.')
    }
  }

  async unpublish(id) {
    const response = await Vue.prototype.$http.put(
      `${config.apiUrl}${PAGE_ROUTES.BASE_URL}/${id}/${PAGE_ROUTES.UNPUBLISH}`
    );

    if (!!response) {
      NotificationService.success('Page has been unpublished.')
    }
  }
}

export default new PageApiService();